import React from 'react';
import './MajorAndJazz.css'
import DogCard from 'components/DogCard/DogCard';
// import useDogsData from 'pages/Dogs/hooks/useDogsData';
import LoadingView from 'components/LoadingView';
import { useFirebaseProviders } from 'modules/Firebase/FirebaseProvider';
import {useCollection, useDocument} from 'react-firebase-hooks/firestore';
import { getFirestore, doc } from 'firebase/firestore';
import useDogsData from "pages/Dogs/hooks/useDogsData";
import Dogs from "pages/Dogs/Dogs";

export default function MajorAndJazz() {
    const [majorData, majorloading] = useMajorData() || [];
    const [jazzData, jazzDataloading] = useJazzData() || [];
    const loading = majorloading || jazzDataloading
    const [dogsData, loadingPuppies] = useDogsData() || [];

console.log('>>',dogsData)
    if (loading) return <LoadingView />;


    return (
        <section className={'dogs rounds-bg'}>
            <div className={'stripes-bg'}>
                <div className={'dogs-list '}>
                    <DogCard dogRef={majorData} id={majorData.id} key={majorData.id} />
                    <span className={'and'}>&</span>
                    <DogCard dogRef={jazzData} id={jazzData.id} key={jazzData.id} />
                </div>
                <PuppiesLabel/>
                <Dogs/>
                {/*<div className={'dogs-list__puppies shadow'}>*/}
                {/*    <img className={'dog-detail__cert shadow'} src={"https://firebasestorage.googleapis.com/v0/b/musical-shepherds.appspot.com/o/img%2Fsingle%2FDSC02323.jpeg?alt=media&token=49396cb4-247d-4664-b1d6-6058da47b63e"}/>*/}
                {/*    <img className={'dog-detail__cert shadow'} src={"https://firebasestorage.googleapis.com/v0/b/musical-shepherds.appspot.com/o/img%2Fsingle%2FIMG_0381.jpg?alt=media&token=79836120-c4a6-4778-8acb-be473f2e0a75"}/>*/}
                {/*</div>*/}
            </div>
        </section>
    );
}

function PuppiesLabel() {
    return (
        <div className={`major-jazz-puppies-label`} >
            <p className={'puppies-label__text'}>7 gorgeous puppies 4 days old - 3 girls ( 2 black tri's, 1 blue merle ) and 4 boys ( 3 blu merles, 1 black tri )</p>
        </div>
    );
}


function useMajorData() {
    const { firestore } = useFirebaseProviders();
    return useDocument(firestore.collection('dogs').doc('OaelJ4dFkGXT3WiwEpcR'),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );
}

function useJazzData() {
    const { firestore } = useFirebaseProviders();
    return useDocument(firestore.collection('dogs').doc('oak3kB1k6tS9lJzHT20i'),
        {
            snapshotListenOptions: { includeMetadataChanges: true },
        }
    );
}
